import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { connectEmployeeToFlexMatchRequest } from 'RestAPIs/flex-match';

export type ConnectEmployeeToFlexMatchRequestPayload = {
  taskId: string;
  body: {
    formdata: {
      actions: 'connect';
      employeeId: number;
      workAgreementId: number;
    };
  };
};

const useConnectEmployeeToFlexMatchRequest = ({
  isWebSocketUpdate = false
}: {
  isWebSocketUpdate?: boolean;
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: ConnectEmployeeToFlexMatchRequestPayload) =>
      connectEmployeeToFlexMatchRequest(payload),
    {
      onSuccess: async () => {
        !isWebSocketUpdate &&
          (await queryClient.refetchQueries('flexMatchTasks'));
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useConnectEmployeeToFlexMatchRequest;
